import { render, staticRenderFns } from "./InstallerFileRow.vue?vue&type=template&id=35e32e16&scoped=true"
import script from "./InstallerFileRow.vue?vue&type=script&lang=js"
export * from "./InstallerFileRow.vue?vue&type=script&lang=js"
import style0 from "./InstallerFileRow.vue?vue&type=style&index=0&id=35e32e16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e32e16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VRow})
